<template>
  <vx-card :title="selectedView" class="shadow-md">
    <div slot="actions">
      <vs-select autocomplete label class="mt-5 w-full" v-model="selectedView" @change="changeView">
        <vs-select-item
          :key="index"
          :value="item.value"
          :text="item.text"
          v-for="(item, index) in availableViews"
        />
      </vs-select>
    </div>
    <div>
      <gmap-map
        :center="center"
        :zoom="zoom"
        @zoom_changed="update('zoom', $event)"
        style="width: 100%; height: 600px"
      >
        <gmap-cluster :zoom-on-click="true" :grid-size="gridSize">
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen = false"
          >
            <vx-card
              style="width:300px;border-radius: 0px;box-shadow: none;"
              v-if="
                selectedView == 'All Modems' ||
                  subSelectedView == 'insideLocation'
              "
            >
              <h5 class="mb-2 text-center">{{ infoContent.name }}</h5>
              <p class="text-black mb-1">
                <b>SmartLink ID:</b>
                {{ infoContent.modemId }}
              </p>
              <p class="text-black mb-1">
                <b>SmartLink Location:</b>
                {{ infoContent.modemLocationName }}
              </p>
              <p class="text-black mb-1">
                <b>Smartlink Zone:</b>
                {{ getZoneName(infoContent.modemZoneId) }}
              </p>
              <p class="text-black mb-1">
                <b>SmartLink Address:</b>
                {{ infoContent.address }}
              </p>
              <p class="text-black mb-1">
                <b>Coverage Radius:</b>
                {{ infoContent.coverageRadius }} Meters
              </p>
              <p class="text-black mb-1">
                <b>Status:</b>
                <span
                  class="text-success"
                  v-if="infoContent.status == 'Online'"
                >{{ infoContent.status }}</span>
                <span class="text-danger" v-else>{{ infoContent.status }}</span>
              </p>
              <div
                class="flex flex-wrap items-center justify-center"
                slot="footer"
                v-if="subSelectedView == 'insideLocation'"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-rotate-ccw"
                  @click="viewZoneLocations(masterId)"
                >Back</vs-button>
              </div>
            </vx-card>
            <vx-card
              style="width:300px;border-radius: 0px;box-shadow: none;"
              v-if="selectedView == 'All Zones' && subSelectedView == ''"
            >
              <h5 class="mb-2 text-center">{{ infoContent.name }}</h5>
              <p class="text-black mb-1">
                <b>State:</b>
                {{ infoContent.insideState }}
              </p>
              <p class="text-black mb-1">
                <b>District:</b>
                {{ infoContent.district }}
              </p>
              <p class="text-black mb-1">
                <b>Zone Address:</b>
                {{ infoContent.address }}
              </p>
              <p class="text-black mb-1">
                <b>Zone Locations:</b>
                {{ infoContent.zoneLocations }}
              </p>
              <div class="flex flex-wrap items-center justify-center" slot="footer">
                <vs-button
                  v-if="
                    infoContent.zoneLocations ==
                      'No Location Added In This Zone'
                  "
                  disabled
                >View Locations</vs-button>
                <vs-button v-else @click="viewZoneLocations(infoContent.id)">View Locations</vs-button>
              </div>
            </vx-card>
            <vx-card
              style="width:300px;border-radius: 0px;box-shadow: none;"
              v-if="
                (selectedView == 'All Locations' && subSelectedView == '') ||
                  subSelectedView == 'insideZone'
              "
            >
              <h5 class="mb-2 text-center">{{ infoContent.name }}</h5>
              <p class="text-black mb-1">
                <b>Inside Zone:</b>
                {{ infoContent.locationZoneName }}
              </p>
              <p class="text-black mb-1">
                <b>SmartLink Name:</b>
                {{ infoContent.locationModems }}
              </p>
              <p class="text-black mb-1">
                <b>Location Address:</b>
                {{ infoContent.address }}
              </p>
              <div class="flex flex-wrap items-center justify-center" slot="footer">
                <vs-button
                  class="mb-2"
                  v-if="
                    infoContent.locationModems ==
                      'No Modem Added In This Location'
                  "
                  disabled
                >View SmartLinks</vs-button>
                <vs-button
                  class="mb-2"
                  v-if="
                    infoContent.locationModems !=
                      'No Modem Added In This Location'
                  "
                  @click="viewLocationModems(infoContent.id)"
                >View SmartLinks</vs-button>
                <vs-button
                  v-if="subSelectedView != ''"
                  icon-pack="feather"
                  icon="icon-rotate-ccw"
                  @click="gotoAllZone()"
                >Back</vs-button>
              </div>
            </vx-card>
          </gmap-info-window>
          <gmap-marker
            :key="i"
            v-for="(m, i) in mainView"
            :position="m.coordinates"
            :clickable="true"
            :label="m.label"
            :icon="m.icon"
            @click="toggleInfoWindow(m, i)"
          ></gmap-marker>
          <!-- <gmap-circle :center="editedItem.coordinates" :radius="editedItem.radius" ></gmap-circle> -->
          <gmap-circle
            v-for="(pin, index) in mainView"
            :key="'e' + index"
            :center="pin.coordinates"
            :radius="pin.coverageRadius"
            :visible="true"
            :options="{
              clickable: false,
              fillColor: '#cccccc57',
              fillOpacity: 0.6,
              strokeColor: '#313131',
              strokeOpacity: 0.4,
              strokeWeight: 0.7
            }"
          ></gmap-circle>
        </gmap-cluster>
      </gmap-map>
    </div>
  </vx-card>
</template>

<script>
import vSelect from "vue-select";
export default {
  data() {
    return {
      center: { lat: 47.376332, lng: 8.547511 },
      zoom: 7,
      infoContent: "",
      gridSize: 100,
      selectedView: "All Zones",
      endpoint: this.$store.state.endpoint2,
      masterId: "",
      subSelectedView: "",
      availableViews: [
        { text: "All Zones", value: "All Zones" },
        { text: "All Locations", value: "All Locations" },
        { text: "All SmartLinks", value: "All Modems" }
      ],
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: { width: 0, height: -35 }
      },
      modems: [],
      locations: [],
      zones: [],
      mainView: []
    };
  },
  created() {
    var modems = JSON.parse(JSON.stringify(this.$store.getters.modems));
    var locationData = JSON.parse(
      JSON.stringify(this.$store.getters.locations)
    );
    var zoneData = JSON.parse(JSON.stringify(this.$store.getters.zones));
    //get name funtions
    function getLocationName(locationId) {
      for (var m in locationData) {
        if (locationData[m].id == locationId) {
          return locationData[m].name;
        }
      }
    }
    function getZoneName(zoneId) {
      for (var n in zoneData) {
        if (zoneData[n].id == zoneId) {
          return zoneData[n].name;
        }
      }
    }
    function getZoneId(locationId) {
      for (var n in locationData) {
        if (locationData[n].id == locationId) {
          return locationData[n].locationZone;
        }
      }
    }
    function getModemName(modemId) {
      for (var l in modems) {
        if (modems[l].id == modemId) {
          return modems[l].name;
        }
      }
    }
    function getLocationModems(locId) {
      var modemList = [];
      for (var a in modems) {
        if (modems[a].insideLocation == locId) {
          modemList.push(modems[a].name);
        }
      }
      if (modemList.length == 0) {
        return "No Modem Added In This Location";
      } else {
        return modemList.toString();
      }
    }
    function getZoneLocations(zoneId) {
      var locationList = [];
      for (var b in locationData) {
        if (locationData[b].locationZone == zoneId) {
          locationList.push(locationData[b].name);
        }
      }
      if (locationList.length == 0) {
        return "No Location Added In This Zone";
      } else {
        return locationList.toString();
      }
    }
    //change data sets
    for (var o in modems) {
      modems[o].modemLocationName = getLocationName(modems[o].insideLocation);
      modems[o].modemZoneId = getZoneId(modems[o].insideLocation);
      modems[o].label = {
        color: "black",
        fontWeight: "bold",
        fontSize: "16px",
        text: modems[o].name
      };
      modems[o].icon = {
        url: require(`@/assets/images/status1.png`),
        labelOrigin: { x: 15, y: 65 }
      };
    }
    for (var p in locationData) {
      locationData[p].locationZoneName = getZoneName(
        locationData[p].locationZone
      );
      locationData[p].label = {
        color: "black",
        fontWeight: "bold",
        fontSize: "16px",
        text: locationData[p].name
      };
      locationData[p].icon = {
        url: require(`@/assets/images/location.png`),
        labelOrigin: { x: 32, y: 75 }
      };
      locationData[p].locationModems = getLocationModems(locationData[p].id);
    }
    for (var q in zoneData) {
      zoneData[q].label = {
        color: "black",
        fontWeight: "bold",
        fontSize: "16px",
        text: zoneData[q].name
      };
      zoneData[q].icon = {
        url: require(`@/assets/images/zone.png`),
        labelOrigin: { x: 32, y: 75 }
      };
      zoneData[q].zoneLocations = getZoneLocations(zoneData[q].id);
    }
    this.modems = modems;
    this.zones = zoneData;
    this.locations = locationData;
    this.mainView = zoneData;
    this.center = zoneData[0].coordinates;
  },
  methods: {
    toggleInfoWindow: async function(marker, idx) {
      console.log(marker);
      console.log(idx);
      if (marker.modemId != undefined) {
        var startTime = moment()
          .subtract(15, "minutes")
          .format("YYYY-MM-DD HH:mm:ss");
        var endTime = moment().format("YYYY-MM-DD HH:mm:ss");
        var payload = {
          modemid: marker.modemId,
          tsl: startTime,
          tsh: endTime,
          idxl: 0,
          idxh: 0,
          limit: 100
        };

        await this.$http.post(this.endpoint + "/api/raw_data", payload).then(
          response => {
            var res = response.data;
            console.log(res);
            if (res.length > 0) {
              marker.status = "Online";
            } else {
              marker.status = "Offline";
            }
          },
          error => {
            console.log(error);
          }
        );
      }
      this.infoWindowPos = marker.coordinates;
      this.center = marker.coordinates;
      this.infoContent = marker;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    changeView() {
      this.infoWinOpen = false;
      this.subSelectedView = "";
      this.zoom = 7;
      if (this.selectedView == "All Modems") {
        this.mainView = this.modems;
        var modems = this.modems;
        this.center = modems[0].coordinates;
      } else if (this.selectedView == "All Locations") {
        this.mainView = this.locations;
        var locations = this.locations;
        this.center = locations[0].coordinates;
      } else {
        this.mainView = this.zones;
        var zones = this.zones;
        this.center = zones[0].coordinates;
      }
    },
    changeView2() {
      this.infoWinOpen = false;
      this.subSelectedView = "";
      this.zoom = 7;
      this.mainView = this.locations;
      var locations = this.locations;
      this.center = locations[0].coordinates;
    },
    getZoneName(zoneId) {
      var zoneData = JSON.parse(JSON.stringify(this.$store.state.zones));

      for (var m in zoneData) {
        if (zoneData[m].id == zoneId) {
          return zoneData[m].name;
        }
      }
    },
    update(field, event) {
      this.$set(this, field, event);
    },
    gotoAllZone() {
      this.selectedView = "All Zones";
      this.changeView();
    },
    viewZoneLocations(zoneId) {
      if (this.selectedView == "All Locations") {
        this.selectedView == "All Locations";
        this.changeView2();
      } else {
        this.subSelectedView = "insideZone";
        this.masterId = zoneId;
        var locations = this.locations;
        var locationList = [];
        for (var loc in locations) {
          if (locations[loc].locationZone == zoneId) {
            locationList.push(locations[loc]);
          }
        }
        this.mainView = locationList;
        this.center = locationList[0].coordinates;
        this.zoom = 15;
        this.infoWinOpen = false;
      }
    },
    viewLocationModems(locationId) {
      this.subSelectedView = "insideLocation";
      var modems = this.modems;
      var modemList = [];
      for (var mod in modems) {
        if (modems[mod].insideLocation == locationId) {
          modemList.push(modems[mod]);
        }
      }
      this.mainView = modemList;
      this.center = modemList[0].coordinates;
      this.zoom = 16;
      this.infoWinOpen = false;
    }
  }
};
</script>
